import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  setPreventScroll
} from '../app/actions'

const mapDispatchToProps = dispatch => {
  return {
    unlockScroll() {
      dispatch(setPreventScroll(false))
    }
  }
}

class HeroIntro extends Component {

  constructor(props) {
    super(props) 

    this.state = {
      init: false,
      complete: false
    }
  }

  componentDidMount() { 
    const { match, unlockScroll } = this.props
    const exactRoute = match && match.isExact

    if (!exactRoute) {
      // Skip intro 
      unlockScroll()
      this.setState({ complete: true, init: true })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.complete) return
    
    const shouldStart = nextProps.canStart && !this.props.canStart
    
    if (shouldStart && !this.state.init) {
      this.setState({ init: true })
      
      setTimeout(() => {
        this.setState({ progressComplete: true }, () => {
          const forceReflow = this.ref.offsetTop
          if ( forceReflow ) { }
          this.setState({ complete: true })
          this.props.unlockScroll()
        })
      }, 1200)
    }
  }

  render() {
    const { vw, vh } = this.props
    const { complete } = this.state

    const w = 300
    const x = w / vw
    const h = vh * x

    if (isNaN(h)) return (
      <div className="hero__intro--loading"></div>
    )

    if (complete) return null
    
    const className = `hero__intro ${ !this.state.progressComplete ? 'hero__intro--progress' : '' }`

    return (
      <div className={ className } ref={ ref => this.ref = ref }>
        <div className="hero__intro-svg-wrapper">
        <svg className="hero__intro-svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMax meet" viewBox={`0 0 300 ${h}`}>
          <defs>
            <mask id="logo-mask" maskUnits="userSpaceOnUse"
                x="0" y="0" width="300" height={h}>
              <rect className="mask-rect" x="0" y="0" width="300" height={h} fill="white"/>
            </mask>
            <g id="logo-overlay">
            <rect x="0" y="0" width="300" height={h} fill="#f3f1ed"/>
            <path transform={`translate(0 ${h-62})`} id="logo-path" d="M218.9,40.3c-2.4,5.9-3.7,10.8-8.2,10.8h-1.9c-2.3,0-4.3-0.4-4.3-5.4V29.9h2.7c5.1,0,5.7,2.9,6.1,6.6h1.8V22.2
          h-1.8c-0.5,2.9,0.1,5.3-6.1,5.3h-2.7V11.8c0-2,2-2.5,4.2-2.5c2.7,0,5.5,0.5,6.2,2.2l3.1,7.3l1.6-0.1c0,0-0.4-11-0.4-11.4h-26.8v1.9
          c2.5,0.3,5,0.3,5,3.3v35.3c0,3-2.5,2.9-5,3.3v1.9h27.2l0.9-12.5L218.9,40.3z M87.3,46.7c0,3-2.2,4.1-5.7,4.4v1.9h14.4v-1.8
          c-3.1-0.7-6.1-0.5-6.1-5V16.5l22.7,36.7h2.1V13.5c0-2.9,2.3-4.1,5.7-4.3V7.4H106v1.8c3.1,0.5,6.1,0.5,6.1,5v25.1L92.8,7.4H82v1.9
          c0,0,5.4,0.4,5.4,4.2V46.7z M52.1,29.9c0-10.1,3.3-20.7,10.5-20.7C69.5,9.2,73,19.7,73,29.9c0,10.3-3.5,21.6-10.5,21.6
          C55.6,51.5,52.1,40.1,52.1,29.9 M62.6,53.7c12,0,18-12.5,18-23.4c0-11-6.5-23.3-18-23.3c-12,0-18,13-18,23.3
          C44.6,41.2,50.5,53.7,62.6,53.7 M29.1,53.7c5,0,10.8-1.9,11.2-2.7l0.8-10.6l-1.6-0.2c-1.8,4.8-4.5,11.4-9.8,11.4
          C21.9,51.6,18,40.6,18,29.9c0-10.6,3.7-20.8,11.4-20.8c1.7,0,3.3,0.1,4.6,1c1.2,1.2,4.4,9.1,4.4,9.1l1.7-0.1l-0.3-9.8
          C39.4,8.5,34,6.9,29.1,6.9c-12.3,0-18.6,11.7-18.6,23.4C10.5,42,16.7,53.7,29.1,53.7 M167.3,28.8V11.5c0-1.6,1.1-2.1,2.7-2.1
          c2.5,0,8,0.4,8,9.1C178,25.4,173,28.8,167.3,28.8 M140.2,53.7c5,0,10.8-1.9,11.2-2.7l0.8-10.6l-1.6-0.2c-1.8,4.8-4.5,11.4-9.8,11.4
          c-7.8,0-11.6-10.9-11.6-21.7c0-10.6,3.7-20.8,11.4-20.8c1.7,0,3.3,0.1,4.6,1c1.2,1.2,4.4,9.1,4.4,9.1l1.7-0.1l-0.3-9.8
          c-0.4-0.8-5.8-2.5-10.8-2.5c-12.3,0-18.5,11.7-18.5,23.4C121.6,42,127.8,53.7,140.2,53.7 M237,9.4v38.5c0,3-2.5,2.9-5,3.3v1.9h16.9
          v-1.8c-3.1-0.7-4.6-0.9-4.6-5v-37h2.7c4.4,0,5.9,5,6.9,9.5h1.8l0.5-13.4h-1.6c-0.4,1.3-1.2,1.9-3.7,1.9h-21.2c-0.4,0-1.3,0-1.7-1.2
          h-1.6l-2.1,12.3l1.6,0.4c4.3-7.8,5.6-9.5,8.9-9.5H237z M286.8,40.3c-2.4,5.9-3.7,10.8-8.2,10.8h-1.9c-2.3,0-4.3-0.4-4.3-5.4V29.9
          h2.7c5.1,0,5.7,2.9,6.1,6.6h1.8V22.2h-1.8c-0.5,2.9,0.1,5.3-6.1,5.3h-2.7V11.8c0-2.1,2-2.5,4.2-2.5c2.7,0,5.5,0.5,6.2,2.2l3.1,7.3
          l1.6-0.1c0,0-0.4-11-0.4-11.4h-26.8v1.9c2.5,0.3,5,0.3,5,3.3v35.3c0,3-2.5,2.9-5,3.3v1.9h27.2l0.9-12.5L286.8,40.3z M185.5,48.7
          c-0.4-0.8-5.4-14.6-5.4-14.6c-1-2.8-2.5-4.5-5.2-4.5c1.3-0.4,9.7-3.1,9.7-11.1c0-9.9-8.6-11.1-12.3-11.1h-16.1v2
          c3.3,0.2,4.1,0.9,4.1,2.9v36.1c0,2.4-1.8,2.5-4.1,2.9v1.9h15.5v-1.8c-3.1-0.5-4.4-0.6-4.4-4.6V31.2c3,0,4.4,1.2,5.4,3.3l6,16.5
          c0.4,0.7,0.8,2,2.5,2h8.4v-1.9C186.8,50.9,185.9,49.5,185.5,48.7"/></g>
          </defs>
          <use id="nm" xlinkHref="#logo-path" fill="white" />
          <use id="gm" xlinkHref="#logo-overlay" fill="#FD3D2A" mask="url(#logo-mask)"/>
        </svg>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(null, mapDispatchToProps)(HeroIntro))




// WEBPACK FOOTER //
// ./src/components/hero/hero-intro.js